import { useMemo } from 'react';
import { useSelector } from 'react-redux';

import { useAuth } from 'hooks';
import { getSelectedMembers, getActiveList } from 'selectors/lists';
import {
  getAreAllSelected,
  getAreSomeSelected,
} from 'components/common/Table/MultiSelect/helpers';
import licenseType from 'models/licenseType';

import getResearchersConfig from './researchersConfig';
import getOrganisationsConfig from './organisationsConfig';

import { views } from '../../constants';

const useConfig = (
  handleToggleAll,
  handleToggleMember,
  view = views.researchers,
  totalMembers = 0
) => {
  const { user, hasLicense } = useAuth();
  const activeList = useSelector(getActiveList);
  const selectedMembers = useSelector(getSelectedMembers);
  const someSelected = getAreSomeSelected(totalMembers, selectedMembers);
  const allSelected = getAreAllSelected(totalMembers, selectedMembers);
  const canVisitOrgPage = useMemo(
    () => hasLicense([licenseType.industry, licenseType.academic], true),
    [hasLicense]
  );

  const config = useMemo(() => {
    if (view === views.researchers) {
      return getResearchersConfig(
        activeList?.id,
        user,
        selectedMembers,
        someSelected,
        allSelected,
        handleToggleAll,
        handleToggleMember,
        canVisitOrgPage
      );
    }

    return getOrganisationsConfig(
      activeList?.id,
      selectedMembers,
      someSelected,
      allSelected,
      handleToggleAll,
      handleToggleMember
    );
  }, [
    activeList?.id,
    allSelected,
    canVisitOrgPage,
    handleToggleAll,
    handleToggleMember,
    selectedMembers,
    someSelected,
    user,
    view,
  ]);

  return config;
};

export default useConfig;
